// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.validation_modal_header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid var(--border);
  margin-bottom: 20px;
  padding-bottom: 20px;
}

.validation_modal_title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
}

.validation_modal_close_x_icone {
  cursor: pointer;
  opacity: 0.5;
  transition: opacity var(--transition-fast);
}

.validation_modal_close_x_icone:hover {
  opacity: 1;
}

.validation_modal_input_fields {
  width: 300px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 6px 12px;
}

.validation_modal_button_submit {
  padding: 8px 20px;
  border-radius: var(--radius-sm);
  background-color: var(--primary);
  border: none;
  color: white;
  font-weight: 600;
  transition: all var(--transition-fast);
}

.validation_modal_button_submit:hover {
  background-color: var(--primary-hover);
}

.validation_modal_form {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: stretch;
}
`, "",{"version":3,"sources":["webpack://./src/components/ValidationModal/ValidationModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,sCAAsC;EACtC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;AACtB","sourcesContent":[".validation_modal_header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  border-bottom: 1px solid var(--border);\n  margin-bottom: 20px;\n  padding-bottom: 20px;\n}\n\n.validation_modal_title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.validation_modal_close_x_icone {\n  cursor: pointer;\n  opacity: 0.5;\n  transition: opacity var(--transition-fast);\n}\n\n.validation_modal_close_x_icone:hover {\n  opacity: 1;\n}\n\n.validation_modal_input_fields {\n  width: 300px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 6px 12px;\n}\n\n.validation_modal_button_submit {\n  padding: 8px 20px;\n  border-radius: var(--radius-sm);\n  background-color: var(--primary);\n  border: none;\n  color: white;\n  font-weight: 600;\n  transition: all var(--transition-fast);\n}\n\n.validation_modal_button_submit:hover {\n  background-color: var(--primary-hover);\n}\n\n.validation_modal_form {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: stretch;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
